import { CalendarOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { List } from 'antd'
import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import { Flag } from '../countries'
import { renderMenuInList } from './TournamentMenu'

import { formatDate } from '../../helpers/date'
import routes from '../../helpers/routes'
import { Tournament } from '../../schemas/Tournament'
import './TournamentListItem.css'

type TournamentListItemProps = {
  admin: boolean
  tenant: string
  tourney: Tournament
  removeTournament(id: string): void
}

export const TournamentListItem = ({
  admin,
  tenant,
  tourney,
  removeTournament,
}: TournamentListItemProps) => {
  const dateLabel =
    !tourney.dateTo || tourney.dateFrom === tourney.dateTo
      ? formatDate(tourney.dateFrom)
      : `${formatDate(tourney.dateFrom)} – ${formatDate(tourney.dateTo)}`

  return (
    <List.Item
      className="TournamentListItem__wrapper"
      key={tourney.name}
      actions={renderMenuInList({ admin, tenant, tourney, removeTournament })}>
      <List.Item.Meta
        title={
          <React.Fragment>
            <div className={classNames('TournamentListItem__title', { hidden: !tourney.public })}>
              <Link to={routes.viewResults(tenant, tourney.id)}>
                <span>{tourney.name}</span>
              </Link>
              <Flag iso2={tourney.country} />
            </div>
            <span>
              <EnvironmentOutlined /> {tourney.venue}
            </span>
          </React.Fragment>
        }
        description={
          <span>
            <CalendarOutlined /> {dateLabel}
          </span>
        }
      />
    </List.Item>
  )
}



// WEBPACK FOOTER //
// ./src/components/tournament/TournamentListItem.tsx